import styled from 'styled-components';
import { colors } from '../../constants';

export const ErrorBox = styled.p`
    padding: 16px 24px;
    border-radius: 3px;
    background-color: ${colors.errorLight};
    color: ${colors.error};
    font-size: 14px;
`;
